import shopifyGenericDefaults from '../shopify-generic/config.js';

const tiresFields = shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;

window.Convermax.showVerifyFitment = () => {
  toggleVisibility('.cm_vehicle-widget__verify-fitment', '.cm_vehicle-widget__verify-fitment-header', true);
};

function onVerifyFitmentInitResponseReceived(response) {
  const container = document.querySelector('.cm_vehicle-widget__verify-fitment-container');
  if (!container) {
    return;
  }

  const item = response?.Items?.[0];
  const fits = item?.fitsTheVehicle;

  setTimeout(() => {
    toggleVisibility(
      '.cm_vehicle-widget__verify-fitment',
      '.cm_vehicle-widget__verify-fitment-header',
      !!fits,
      container,
    );
  }, 0);
}

function toggleVisibility(widgetSelector, headerSelector, showWidget, context = document) {
  const widget = context.querySelector(widgetSelector);
  const header = context.querySelector(headerSelector);

  if (showWidget) {
    widget?.classList.remove('cm_hide');
    header?.classList.add('cm_hide');
  } else {
    widget?.classList.add('cm_hide');
    header?.classList.remove('cm_hide');
  }
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    extra: {
      ...shopifyGenericDefaults.SearchRequestDefaults.extra,
      doNotHideWheelsTiresFacets: window.location.pathname === '/' || window.location.pathname === '/fr',
    },
  },
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    onVerifyFitmentInitResponseReceived,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['VerifyFitment', 'TirePanel_tab'].includes(w.name)),
    {
      name: 'VerifyFitment',
      location: {
        selector: '#cm-verify-fitment',
        class: 'cm_vehicle-widget__verify-fitment-container',
      },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 1000,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#cm-tire-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/collections/tires',
      selectFields: tiresFields,
    },
  ],
};
